module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3460959.53ac1f2a.png";